class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchWrap = this.querySelector('.predictive-search--search-template');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingSearches = this.querySelector('[data-trending-searches]');
    this.clearBtn = this.querySelector('[data-clear-predictive-search]');

    this.input.addEventListener('click', () => {
      this.open();
      if (this.input.value.length == 0) {
        this.showTrendingSearches();
        this.hideResult();
      } else {
        this.hideTrendingSearches();
        this.showResult();
      }
    });

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 500).bind(this));

    this.clearBtn.addEventListener('click', () => {
      this.input.value = '';
      this.showTrendingSearches();
      this.hideResult();
    });
  }

  onChange() {
    const searchTerm = this.input.value;

    if (searchTerm.length == 0) {
      this.showTrendingSearches();
      this.hideResult();
    } else {
      this.hideTrendingSearches();
      this.showResult();
      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    fetch('/search/suggest?q='+searchTerm+'&resources[type]=collection,product&resources[options][fields]=title,product_type,body,vendor,tag,variants.title&resources[limit]=6&section_id=predictive-search')
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#api-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        let resultCheck = document.querySelector('.predictive-search-results').getAttribute('data-result');
        // console.log(resultCheck);
        if(resultCheck == 'false') {
          this.showTrendingSearches();
        } else {
          this.hideTrendingSearches();
        }

        // this.open();
      })
      .catch((error) => {
        this.showTrendingSearches();
        //this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchWrap.style.display = 'block';
    document.querySelector('body').classList.add('body-overflow-hidden');
  }

  close() {
    this.predictiveSearchWrap.style.display = 'none';
    document.querySelector('body').classList.remove('body-overflow-hidden');
  }

  showTrendingSearches() {
    this.trendingSearches.style.display = 'block';
  }

  hideTrendingSearches() {
    this.trendingSearches.style.display = 'none';
  }

  showResult() {
    this.predictiveSearchResults.style.display = 'block';
    this.clearBtn.style.display = 'block';
  }

  hideResult() {
    this.predictiveSearchResults.style.display = 'none';
    this.clearBtn.style.display = 'none';
  }
}

customElements.define('predictive-search', PredictiveSearch);

checkHeaderHeight();
openSearchPopup();
closeSearchPopup();
window.addEventListener('resize', function() {
  checkHeaderHeight();
});

document.addEventListener('click', function(event) {
  if(window.innerWidth > 749) {
    if (
      event.target.matches('[data-clear-predictive-search]') == false &&
      event.target.matches('input[type="search"]') == false &&
      !event.target.closest('.predictive-search--search-template') == true
    ) {
      closeAll();
    }
  }
});

function closeAll() {
  document.querySelectorAll('.predictive-search--search-template').forEach(template => template.style.display = 'none');
  document.querySelector('body').classList.remove('body-overflow-hidden');
}

function checkHeaderHeight() {
  let height = document.querySelector('.custom-header-wrapper').offsetHeight;
  document.querySelectorAll('.predictive-search--search-template').forEach(template => template.style.maxHeight = 'calc(100vh - '+ height + 'px)');
}

function openSearchPopup() {
  document.querySelector('[data-open-popup-search]').addEventListener('click', () => {
    document.querySelector('.header-predictive-search').classList.add('open');
    document.querySelector('body').classList.add('body-overflow-hidden');
  });
}

function closeSearchPopup() {
  document.querySelector('[data-close-popup-search]').addEventListener('click', () => {
    document.querySelector('.header-predictive-search').classList.remove('open');
    document.querySelector('body').classList.remove('body-overflow-hidden');
  });

}

const searchForm = document.getElementById('Search-In-Modal');
const searchFormMobile = document.getElementById('Search-In-Modal-mob');

function onKeyUp(event, search) {
  event.preventDefault();
  const selectedPredictionItem = document.querySelectorAll('.predict-selected')[0];
  const SPItemUrl = (selectedPredictionItem) ? selectedPredictionItem.href : '';
  var eventObj = {};
  if (selectedPredictionItem) {
    eventObj.thisComponent = selectedPredictionItem.getAttribute('data-eventComponent');
    eventObj.thisEventVal = selectedPredictionItem.getAttribute('data-eventValue');
  }

  if (event.key === 'Enter') {
    eventObj.thisComponent = 'Header Search - Query'
    eventObj.thisEventVal = search.value;
    console.log(SPItemUrl);
    s_pushEventNoRedirect(SPItemUrl, s_eventPushCallback(eventObj));
  }
}
searchForm.addEventListener('keyup', function(event) {
  onKeyUp(event, searchForm);
});

searchFormMobile.addEventListener('keyup', function(event) {
  onKeyUp(event, searchFormMobile);
});

function s_redirectToLink(thisLink, eventPushCallback) {
  // console.log('redirect', thisLink);
  setTimeout(function() {
    window.location.href = thisLink;
  }, 100);
}

function s_pushEventNoRedirect(thisLink, eventPushCallback) {
  setTimeout(function() {
    if (thisLink) {
      window.location.href = thisLink;
    }
    // window.location.href = thisLink;
  }, 100);
}

function s_eventPushCallback(eventObj) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'uxTracking',
    'siteComponent': eventObj.thisComponent,
    'componentLabel': eventObj.thisEventVal
  });
  console.log('push data', eventObj);
}
